import { render, staticRenderFns } from "./AdminClaimsWidget.vue?vue&type=template&id=264bf53d"
import script from "./AdminClaimsWidget.vue?vue&type=script&lang=js"
export * from "./AdminClaimsWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports